<template>
    <div class="i-list-editor">
        <i-list :fields="fields" :data="data_list" @input="editItem" />
        <modal :title="i_settings.title" :name="`${name}-edit-modal`" :height="i_settings.modalHeight" :width="i_settings.modalWidth">
            <i-form :layout="layout" :editMode="editMode" :scheme="scheme" :padding="8" :value="selectedItem" :name="`${name}-edit-form`" @input="saveForm" :columns="i_settings.formColumns" :height="i_settings.modalHeight-78" />
            <controls slot="footer" v-if="!i_settings.readOnly" :showRemove="i_settings.allowRemove" @remove="removeItem" @save="saveItem" />
        </modal>
        <btn l="Добавить" i="plus" @press="createItem" />
    </div>
</template>
<script>
import iList from "./i-list.vue";
import Modal from "../desktop/modal.vue";
import Controls from "./i-modal-control-buttons.vue";
import _ from "lodash";

export default {
    name: 'i-list-editor',
    components: { Modal, iList, Controls },
    mounted(){
        console.log(this.value)
    },
    props: {
        "name": {
            type: String,
            default () {
                return _.random(0, 9999999999) + "";
            }
        },
        "editMode": {
            type: Boolean
        },
        "action": {
            type: String
        },
        "scheme": {
            type: Object,
            required: true
        },
        "layout": {
            type: Object
        },
        "value": {
            type: Array,
            required: true
        },
        "settings": {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        async saveForm(formData) {
            let { saveAction } = this.i_settings;
            let { data_list, action, selectedIndex } = this;
            if (action) {
                saveAction = action + 'Save';
            }
            /*
                        if (formData._id) {
                            this.$store.dispatch(saveAction, formData.getChanged());
                            let foundIndex = data_list.findIndex(d => d._id === formData._id);
                            console.log(foundIndex, data_list[foundIndex])
                            this.data_list = _.merge(data_list, {
                                [foundIndex]: formData
                            });
                            this.$forceUpdate();
                        } else {
                            let _id = await this.$store.dispatch(saveAction, formData.getChanged());
                            this.data_list = _.concat(data_list, [Object.assign({ _id }, formData)]);
                        }*/


            this.data_list[selectedIndex] = formData;
            this.closeModal(`${this.name}-edit-modal`);
            this.$emit('save', this.data_list);
            this.$store.dispatch(saveAction, formData.getChanged());
        },
        saveItem() {
            let { name } = this;
            _i.bus.$emit('save-form', `${name}-edit-form`);
        },
        removeItem() {
            let { removeAction } = this.i_settings;
            let { action } = this;
            if (action) {
                removeAction = action + 'Remove';
            }
            console.log(this.selectedItem)
            this.$store.dispatch(removeAction, this.selectedItem._id);
        },
        editItem(item, idx) {
            this.selectedItem = item;
            this.selectedIndex = idx;
            this.openModal(`${this.name}-edit-modal`);
        },
        createItem(item) {
            this.selectedItem = {};
            this.openModal(`${this.name}-edit-modal`);
        }
    },
    beforeMount() {
        if (this.value) {
            this.data_list = this.value;
        }
        
    },
    computed: {
        i_settings() {
            return Object.assign({}, {
                readOnly: false,
                allowRemove: true,
                saveAction: "saveItem",
                removeAction: "removeItem",
                formColumns: 1,
                title: 'Редактировать'
            }, this.settings);
        },
        fields() {
            let { scheme } = this;
            console.log(scheme)
            let fields = Object.keys(scheme).reduce((ns, i) => {
                if (scheme[i].index) {
                    scheme[i].name = i;
                    ns.push(scheme[i]);
                }
                return ns;
            }, [{ type: "index", label: "№", index: 0 }]);
            return _.sortBy(fields, "index")
        }
    },
    data() {
        return {
            selectedItem: false,
            data_list: []
        }
    }
}
</script>
<style lang="css" scoped>
</style>